"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import Account from "../../api/account";
import AutoConfirmedLoadHeader from "../auto_confirmed_load_header";
import InvoiceInputFields from "./invoice_input_fields";
import {
  cleanedInvoiceFields,
  initialInvoiceFieldsState,
  invoiceFieldsStateUpdate
} from "./invoice_fields_state";
import LoadAssignerProgress, {
  getLoadAssignerProgressItems
} from "./load_assigner_progress";
import LoadTable from "./load_table";
import LoadSearchArea from "./load_search_area";
import DocumentExceptionArea from "./document_exception_area";
import CarrierChooser from "./carrier_chooser";
import CarrierInvoiceChooser from "./carrier_invoice_chooser";
import DocumentTitle from "../../components/document_title";
import reactUtils from "../../react_utils";
import ToDashboardWithFilters from "../ui/to_dashboard_with_filters";
import Auth from "../../util/auth";
var bem = reactUtils.makeBem("document-group-editor");
function hasGuessedLoad(props) {
  return props.loads.guessed.length > 0 || props.loads.selected;
}
function hasInvoices(props) {
  return props.invoicesForGroup.length > 0;
}
function selectedLoadHasCustomerCustomExceptionMessages(props) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  return ((_e = (_d = (_c = (_b = (_a = props.loads.selectedLoad) == null ? void 0 : _a.load) == null ? void 0 : _b.customer) == null ? void 0 : _c.settings["rules_broker_custom_exception_messages"]) == null ? void 0 : _d.length) != null ? _e : 0) > 0 || ((_j = (_i = (_h = (_g = (_f = props.loads.selectedLoad) == null ? void 0 : _f.load) == null ? void 0 : _g.tms_load_shipments) == null ? void 0 : _h.flatMap(
    (s) => {
      var _a2;
      return (_a2 = s.customer_custom_exception_messages) != null ? _a2 : [];
    }
  )) == null ? void 0 : _i.length) != null ? _j : 0) > 0;
}
function selectedLoadUsesNidf(props) {
  var _a, _b, _c;
  return (_c = (_b = (_a = props.loads.selectedLoad) == null ? void 0 : _a.load) == null ? void 0 : _b.nidf_enabled) != null ? _c : true;
}
function rerouteNidfToException(props) {
  return selectedLoadUsesNidf(props) && Auth.getCurrentUser().managed_indexer && Account.preventNidfToLoadWithCustomerCustomExceptionMessagesEnabled() && selectedLoadHasCustomerCustomExceptionMessages(props);
}
function showAssignLoadsContent(props, state) {
  return (!state.showExceptions || state.showExceptions && activeExceptions(props).length > 0) && !state.recentlyResolved;
}
function assignLoadsHeader(props) {
  var selectedLoad = props.loads.selectedLoad;
  var text = "Assign Load to This Document Group";
  if (selectedLoad && !selectedLoad.load.load_is_auto_confirmed) {
    return /* @__PURE__ */ jsx("h3", { children: text });
  } else if (!selectedLoad) {
    return /* @__PURE__ */ jsx("h3", { children: text });
  }
}
function possibleSelectLoadTextNumbering(props) {
  if (props.multiCarrier) {
    return /* @__PURE__ */ jsx("strong", { children: "1." });
  }
}
function autoConfirmedLoadHeader(props) {
  return /* @__PURE__ */ jsx(
    AutoConfirmedLoadHeader,
    {
      carrierInvoice: null,
      load: props.loads.selectedLoad
    }
  );
}
function loadsNotFromEmailCarrier(props, loadState) {
  return props.email.carrier_id && loadState.load.carrier_id !== props.email.carrier_id;
}
function possibleNonMatchingCarrierWarning(props) {
  if (_.find(
    props.loads.guessed,
    (loadState) => loadsNotFromEmailCarrier(props, loadState)
  )) {
    return /* @__PURE__ */ jsx("div", { className: "alert-box--caution", children: /* @__PURE__ */ jsxs("span", { children: [
      "At least one of the following loads is assigned to a",
      " ",
      Account.carrierTermLower(),
      " that does not match the",
      " ",
      Account.carrierTermLower(),
      " assigned to this email."
    ] }) });
  }
}
function carrierChooser(props) {
  if (props.loads.selected && !props.documentBatch.single_carrier) {
    return /* @__PURE__ */ jsxs("div", { className: "load-assigner__carrier-chooser", children: [
      possibleMultipleGuessedCarriersNotification(props),
      /* @__PURE__ */ jsxs("h6", { children: [
        /* @__PURE__ */ jsx("span", { className: "paragraph__possible-select-load-text-numbering", children: /* @__PURE__ */ jsx("strong", { children: "2." }) }),
        " ",
        "Select a ",
        Account.carrierTermLower(),
        " for this group (optional):"
      ] }),
      /* @__PURE__ */ jsx(
        CarrierChooser,
        {
          carrierGuesses: props.carrierGuesses(),
          state: props.carrierChooserState,
          allowIndexingCustomerOnlyDocuments: isIndexCustomerOnlyDocsEnabled(
            props
          ),
          onUpdate: props.onCarrierChooserUpdate
        }
      )
    ] });
  }
}
function guessedLoadsContent(props, state) {
  if (!state.showSearch) {
    return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
      LoadTable,
      {
        items: props.loads.guessed,
        highlightChanged: props.highlightReference,
        selectedLoadStateId: props.loads.selected,
        highlightedLoads: _.pluck(props.loads.guessed, "id"),
        loadsNotFromEmailCarrier: (loadState) => loadsNotFromEmailCarrier(props, loadState),
        onSelectionChange: props.setSelectedLoad
      }
    ) });
  }
}
function possibleMultipleGuessedCarriersNotification(props) {
  if (props.documentGroup.multiple_guessed_carriers) {
    return /* @__PURE__ */ jsxs("div", { className: "alert-box--progress", children: [
      "TriumphPay Audit was unable to automatically assign a",
      " ",
      Account.carrierTermLower(),
      " to this group because multiple different",
      " ",
      Account.carrierTermLower(),
      "s or multiple matching",
      " ",
      Account.carrierTermLower(),
      "s with similar names were detected in the documents."
    ] });
  }
}
function activeExceptions(props, givenProps) {
  const sourceProps = givenProps ? givenProps : props;
  return _.reject(
    sourceProps.documentGroup.exception_events,
    _.property("resolved_at")
  );
}
function isIndexCustomerOnlyDocsEnabled(props) {
  return Account.currentSettings().allow_indexing_customer_only_documents && props.documentBatch.customer_only;
}
function showInvoiceChooserForCustomerOnlyDocs(props) {
  return props.loads.selected && props.assignCustomerOnlyDocuments && isIndexCustomerOnlyDocsEnabled(props);
}
const NO_INVOICE = { id: "none" };
const NEW_INVOICE = { id: "new" };
function defaultInvoice(props) {
  return selectedLoadUsesNidf(props) ? NO_INVOICE : NEW_INVOICE;
}
function selectedInvoiceId(props) {
  const id = props.getSelectedInvoiceForGroup(defaultInvoice(props)).id;
  return !selectedLoadUsesNidf(props) && id === NO_INVOICE.id ? NEW_INVOICE.id : id;
}
export default class extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "invoiceInputFieldsRef", React.createRef());
    __publicField(this, "problemContentRef", React.createRef());
    __publicField(this, "invoiceInputFields", () => {
      if (!Account.currentSettings().index_audit_split_enabled) {
        return null;
      }
      return /* @__PURE__ */ jsx(
        InvoiceInputFields,
        {
          getSelectedInvoiceForGroup: this.props.getSelectedInvoiceForGroup,
          onFieldChange: this.onInvoiceFieldChange,
          sourceInvoiceAmount: this.state.source_invoice_amount,
          sourceInvoiceNumber: this.state.source_invoice_number,
          ref: this.invoiceInputFieldsRef
        }
      );
    });
    __publicField(this, "onInvoiceFieldChange", (field, value) => {
      this.setState({ [field]: value, [`${field}_edited`]: true });
    });
    __publicField(this, "invoiceDataEntered", () => {
      const fields = cleanedInvoiceFields(this.state);
      return !!(fields.source_invoice_amount && fields.source_invoice_number);
    });
    __publicField(this, "focusNextField", () => {
      var _a;
      (_a = this.invoiceInputFieldsRef.current) == null ? void 0 : _a.focusNextField();
    });
    __publicField(this, "assignLoad", () => {
      var selectedLoadId = this.props.loads.selected;
      const fields = cleanedInvoiceFields(this.state);
      this.setState({ saving: true });
      const carrierID = this.props.selectedCarrierID;
      const carrierInvoice = {};
      ["source_invoice_number", "source_invoice_amount"].forEach((field) => {
        if (fields[field]) {
          carrierInvoice[field] = fields[field];
        }
      });
      const invoiceId = selectedInvoiceId(this.props);
      if ((hasInvoices(this.props) || !selectedLoadUsesNidf(this.props)) && invoiceId !== NO_INVOICE.id) {
        this.props.assignCurrentGroupToLoadAndInvoiceId(
          selectedLoadId,
          invoiceId,
          carrierInvoice,
          carrierID,
          false,
          null
        );
        return;
      }
      if (rerouteNidfToException(this.props)) {
        this.props.exceptionCreator("Custom rules found for this customer", false).then(() => {
          if (!this.props.hasMore) {
            console.log("to dashboard with filters");
            ToDashboardWithFilters(this.props.location);
          } else {
            console.log("documents exception added callback");
            this.props.documentsExceptionAddedCallback();
          }
        });
        return;
      }
      this.props.assignCurrentGroupToLoad(selectedLoadId, carrierID).then(() => this.setState({ saving: false }));
    });
    __publicField(this, "toggleExceptions", () => {
      this.setState((prevState) => ({
        showExceptions: !prevState.showExceptions
      }));
    });
    __publicField(this, "showSearch", () => {
      this.setState({ showSearch: true });
    });
    __publicField(this, "cancelSearch", () => {
      this.setState({ showSearch: false });
      this.focusNextField();
    });
    __publicField(this, "carrierSelected", (carrier) => {
      this.setState({ carrier });
    });
    __publicField(this, "assignLoadsContent", () => {
      if (showAssignLoadsContent(this.props, this.state)) {
        return /* @__PURE__ */ jsxs("div", { children: [
          assignLoadsHeader(this.props),
          this.selectLoadText(),
          this.documentGroup(),
          this.possibleExceptionsLink()
        ] });
      }
    });
    __publicField(this, "documentGroup", () => {
      return /* @__PURE__ */ jsxs("div", { className: bem("__group"), children: [
        /* @__PURE__ */ jsx("div", { className: bem("__group-title"), children: this.props.group.name }),
        possibleNonMatchingCarrierWarning(this.props),
        this.loadSearchArea(),
        guessedLoadsContent(this.props, this.state)
      ] });
    });
    __publicField(this, "possibleExceptionsLink", () => {
      if (!this.state.showExceptions) {
        return /* @__PURE__ */ jsxs("p", { className: "load-assigner__report-problem", children: [
          "Still issues?",
          " ",
          /* @__PURE__ */ jsx("a", { onClick: this.toggleExceptions, children: "Create an exception" })
        ] });
      }
    });
    __publicField(this, "selectLoadText", () => {
      if (!this.state.showSearch) {
        var selectedLoad = this.props.loads.selectedLoad;
        var text = selectedLoad && selectedLoad.load.load_is_auto_confirmed ? autoConfirmedLoadHeader(this.props) : "Select a load from the loads we identified in the documents. ";
        return /* @__PURE__ */ jsx("p", { className: "paragraph", children: /* @__PURE__ */ jsxs("span", { children: [
          possibleSelectLoadTextNumbering(this.props),
          text,
          "Not the right ones?",
          " ",
          /* @__PURE__ */ jsx("a", { onClick: this.showSearch, children: "Search for another one" }),
          "."
        ] }) });
      }
    });
    __publicField(this, "progressArea", () => {
      if (this.state.tab !== "exception") {
        return /* @__PURE__ */ jsx("div", { className: "load-assigner__save-buttons", children: /* @__PURE__ */ jsxs("div", { className: "load-assigner__save-buttons-inner", children: [
          this.invoiceInputFields(),
          carrierChooser(this.props),
          hasInvoices(this.props) ? this.invoiceChooser() : "",
          this.messageOrSave()
        ] }) });
      }
    });
    __publicField(this, "invoiceChooser", () => {
      if (this.props.selectedCarrierID || showInvoiceChooserForCustomerOnlyDocs(this.props)) {
        return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
          CarrierInvoiceChooser,
          {
            loadID: this.props.loads.selectedLoad.load.load_id,
            invoicesForGroup: this.props.invoicesForGroup,
            initialInvoiceId: _.first(
              _.compact(
                _.pluck(this.props.group.documents, "carrier_invoice_id")
              )
            ),
            selectedInvoice: this.props.getSelectedInvoiceForGroup(
              defaultInvoice(this.props)
            ),
            carrierID: this.props.selectedCarrierID,
            group: this.props.group,
            noInvoice: selectedLoadUsesNidf(this.props) ? NO_INVOICE : void 0,
            newInvoice: selectedLoadUsesNidf(this.props) ? void 0 : NEW_INVOICE,
            currentlyAssignedInvoice: this.props.currentlyAssignedInvoiceForGroup,
            invoiceSelected: this.props.setSelectedInvoiceForGroup
          }
        ) });
      }
    });
    __publicField(this, "messageOrSave", () => {
      let button;
      if (this.state.saving) {
        button = /* @__PURE__ */ jsx("button", { disabled: true, children: "Saving..." });
      } else if (this.props.loads.selected && this.props.selectedCarrierID) {
        let buttonText = "Continue";
        if (rerouteNidfToException(this.props)) {
          buttonText = "Save as Exception";
        } else if (Account.indexAuditSplitEnabled()) {
          buttonText = "Submit";
        }
        button = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("button", { className: "button--progress ", onClick: this.assignLoad, children: buttonText }) });
      } else if (this.props.loads.selected) {
        button = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs("button", { className: "button--progress ", onClick: this.assignLoad, children: [
          "Continue without selecting ",
          Account.carrierTermLower()
        ] }) });
      } else {
        button = /* @__PURE__ */ jsx("button", { className: "button--disabled", disabled: true, children: "Select a load to continue" });
      }
      const progressItems = getLoadAssignerProgressItems(
        this.props.loads.selectedLoad,
        this.props.documentBatch,
        this.props.documentGroup,
        this.invoiceDataEntered(),
        this.props.shipmentDocumentSelections,
        rerouteNidfToException(this.props),
        this.props.documentLoadRelationships
      );
      return /* @__PURE__ */ jsx("div", { className: bem("__actions"), children: /* @__PURE__ */ jsx(LoadAssignerProgress, { content: button, items: progressItems }) });
    });
    __publicField(this, "recentlyResolved", () => {
      this.setState({ recentlyResolved: true });
    });
    __publicField(this, "closeExceptions", () => {
      this.setState({ recentlyResolved: false, showExceptions: false });
    });
    __publicField(this, "reportProblemContent", () => {
      if (this.state.showExceptions || !this.state.showExceptions && this.state.recentlyResolved) {
        return /* @__PURE__ */ jsx(
          "div",
          {
            className: "load-assigner__document-exception-area panel",
            ref: this.problemContentRef,
            children: /* @__PURE__ */ jsx(
              DocumentExceptionArea,
              {
                closeExceptions: this.closeExceptions,
                location: this.props.location,
                recentlyResolved: this.recentlyResolved,
                hasMore: this.props.hasMore,
                documentsExceptionAddedCallback: this.props.documentsExceptionAddedCallback,
                model: this.props.model,
                email: this.props.email,
                carrier: this.props.carrier,
                selectedLoad: this.props.loads.selectedLoad,
                documentGroup: this.props.documentGroup,
                exceptionResolver: this.props.exceptionResolver,
                exceptionCreator: this.props.exceptionCreator,
                exceptionUpdater: this.props.exceptionUpdater,
                exceptions: activeExceptions(this.props),
                scrollUp: this.scrollUp,
                onCancel: this.toggleExceptions
              }
            )
          }
        );
      }
    });
    __publicField(this, "loadSearchArea", () => {
      if (this.state.showSearch) {
        return /* @__PURE__ */ jsx(
          LoadSearchArea,
          {
            loadsNotFromEmailCarrier: (loadState) => loadsNotFromEmailCarrier(this.props, loadState),
            carrier: this.props.carrier,
            selectedLoadStateId: this.props.loads.selected,
            highlightedLoads: _.pluck(this.props.loads.guessed, "id"),
            searcher: this.props.searcher,
            onSelectionChange: this.props.setSelectedLoad,
            onCancel: this.cancelSearch,
            multiCarrier: this.props.multiCarrier,
            highlightReference: this.props.highlightReference
          }
        );
      }
    });
    __publicField(this, "scrollUp", () => {
      var _a;
      (_a = this.problemContentRef.current) == null ? void 0 : _a.scrollIntoView();
    });
    const guessedLoad = hasGuessedLoad(props);
    this.state = __spreadProps(__spreadValues({
      showExceptions: _.first(activeExceptions(props)),
      showSearch: !guessedLoad,
      showGuessed: guessedLoad
    }, initialInvoiceFieldsState(props)), {
      prevGroup: props.group,
      prevSaving: props.saving
    });
  }
  static getDerivedStateFromProps(props, state) {
    let update = invoiceFieldsStateUpdate(props, state);
    if (props.group !== state.prevGroup) {
      const guessedLoad = hasGuessedLoad(props);
      update = __spreadProps(__spreadValues({}, update), {
        prevGroup: props.group,
        showExceptions: _.first(activeExceptions(props)),
        showSearch: !guessedLoad,
        showGuessed: guessedLoad
      });
    }
    if (props.saving !== state.prevSaving) {
      update = __spreadProps(__spreadValues({}, update), { prevSaving: props.saving, saving: props.saving });
    }
    return update;
  }
  componentDidMount() {
    if (hasGuessedLoad(this.props)) {
      this.focusNextField();
    }
  }
  // RENDER
  render() {
    return /* @__PURE__ */ jsx(DocumentTitle, { title: "TriumphPay Audit \u2013 Assign Loads", children: /* @__PURE__ */ jsxs("div", { className: "load-assigner__root", children: [
      /* @__PURE__ */ jsxs("div", { className: "load-assigner__scrollable-area", children: [
        this.reportProblemContent(),
        this.assignLoadsContent()
      ] }),
      this.progressArea()
    ] }) });
  }
}
